module.exports = __webpack_public_path__ + "img/mbr ell.7273f81e.svg";